<template>
  <div>
    <div>
      <p class="titleColorSystem text-center">Productividad</p>
      <p class="sci-prod-texto">
        En esta sección podrá consultar los productos derivados de la actividad de los investigadores del estado de 
        {{ this.configuracion.estado.nombre }}, tales como artículos científicos, libros, registros de propiedad intelectual o industrial, entre otros.
      </p>
    </div>
    <div class="sci-prod-content">
      <b-row class="sci-prod-row">
        <div class="sci-prod-vcont">
            <v-select
                v-model="prod"
                :items="productividad"
                item-value="id"
                class="sci-prod-vselect"
                item-text="name"
                label="Productividad científica"
                clearable=""
            ></v-select>
            <v-select
            v-if="prod !== 1 && prod !== 2"
                class="sci-prod-vselect"
                item-text="name"
                label="Indicar tipo"
                clearable=""
            ></v-select>
            <v-select
            v-if="prod == 1"
                v-model="type"
                :items="types"
                item-value="producto"
                class="sci-prod-vselect"
                item-text="name"
                label="Indicar tipo"
                clearable=""
            ></v-select>

            <v-select
              v-if="prod == 2"
                v-model="proptype"
                :items="proptypes"
                item-value="propiedad"
                class="sci-prod-vselect"
                item-text="name"
                label="Indicar tipo"
                clearable=""
            ></v-select>
              <!-- v-if="prod == 2" -->
            <v-select
              v-model="year"
              :items="years"
              item-value="fecha_inicio"
              class="sci-prod-vselect"
              item-text="date"
              label="Indicar año"
              clearable=""
            ></v-select>
          <div class="sci-prod-busqueda">
            <div class="sci-prod-busqueda">
              <input v-model="search" type="text" placeholder="Buscar proyecto" autofocus><button  class="sci-prod-lupa"></button>
            </div>
          </div>
          <span v-if="this.prod == 1 && this.type && this.year">
            <vue-excel-xlsx
              class="sci-prod-excel"
              :data="publicacionesExcel.data"
              :columns="columns1"
              :filename="'Publicaciones'"
              :sheetname="'publicaciones'"
            >
              Descargar resultados de publicaciones
            </vue-excel-xlsx>
          </span>
          <span v-if="this.prod == 2 && this.proptype && this.year"> 
            <vue-excel-xlsx
              class="sci-prod-excel"
              :data="propiedadIntelectualExcel.data"
              :columns="columns2"
              :filename="'Propiedad Intelectual'"
              :sheetname="'propiedad intelectual'"
            >
              Descargar resultados de propiedad intelectual
            </vue-excel-xlsx>
          </span>
        </div>
        <thead v-if="prod !== 1 && prod !== 2">
          <div class="sci-prod-noData">
            <span>Sin información. Por favor elija una categoría mediante el select</span>
          </div>
        </thead>
        <thead v-if="prod == 1" class="sci-prod-thead">
          <span class="sci-prod-count">Hay {{ prodCount }} publicaciones que coinciden</span>
          <tr>
            <td class="sci-prod-thead-ti">titulo</td>
            <td class="sci-prod-thead-area">tipo</td>
            <td class="sci-prod-thead-obj">fecha</td>
            <!-- <td class="sci-prod-thead-area">titulo de revista/libro</td> -->
            <td class="sci-prod-thead-tipo">investigador</td>
            <td class="sci-prod-thead-nom">contacto</td>
          </tr>
        </thead>
        <thead v-if="prod == 2" class="sci-prod-thead">
          <span class="sci-prod-count">Hay {{ prodCount }} registros de propiedad intelectual que coinciden</span>
          <tr class="sci-prod-thead2">
            <td class="sci-prod-thead-ti">titulo</td>
            <td class="sci-prod-thead-obj">objetivo</td>
            <td class="sci-prod-thead-area">tipo</td>
            <td class="sci-prod-thead-area">Año de registro</td>
            <td class="sci-prod-thead-tipo">investigador</td>
            <td class="sci-prod-thead-nom">contacto</td>
          </tr>
        </thead>
      </b-row>
      <tbody v-if="prod == 1 && this.type" class="sci-prod-tbody">
        <div>
          <tr v-for="(publicacion, index) in publicaciones.data" :key="index">
            <td class="sci-prod-tbody-ti">{{publicacion.titulo ? publicacion.titulo : "Sin titulo definido"}}</td>
            <td class="sci-prod-tbody-area">{{publicacion.producto}}</td>
            <td class="sci-prod-tbody-obj">{{publicacion.fecha_final ? `${publicacion.fecha_final.substring(0,4)}` : "sin fecha"}}</td>
            <!-- <td class="sci-prod-tbody-tipo">{{publicacion.titulo}}</td> -->
            <td class="sci-prod-tbody-nom">
              {{publicacion.nombre_investigador ? publicacion.nombre_investigador : '' }}
            </td>
            <td style="text-align: center;" v-if="publicacion" @click="openMailModal(publicacion.id, publicacion)">
              <span class="material-icons" style="cursor:pointer;">
                mail_outline
              </span>
            </td>
          </tr>
        </div>
      </tbody>
      <tbody v-if="prod == 2 && this.proptype" class="sci-prod-tbody2">
        <div>
          <tr v-for="(publicacion, i) in propiedadIntelectual.data" :key="i">
            <td class="sci-prod-tbody-ti">{{publicacion.titulo ? publicacion.titulo : "Sin titulo definido"}}</td>
            <td class="sci-prod-tbody-obj">{{publicacion.objetivo ? publicacion.objetivo : "sin objetivo definido"}}</td>
            <td class="sci-prod-tbody-area">{{publicacion.producto}}</td>
            <td class="sci-prod-tbody-tipo">{{ publicacion.fecha_inicio ? `${publicacion.fecha_inicio.substring(0,4)}` : "Sin fecha"  }}</td>
            <td class="sci-prod-tbody-nom">
              {{publicacion.nombre_investigador ? publicacion.nombre_investigador : ''}}
            </td>
            <td style="text-align: center;" v-if="publicacion" @click="openMailModal(publicacion.id, publicacion)">
              <span class="material-icons" style="cursor:pointer;">
                mail_outline
              </span>
            </td>
          </tr>
        </div>
      </tbody>
      <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination v-if="prod == 1" :limit="vPaginator.limit" :data="this.publicaciones" @pagination-change-page="getPublicaciones"></pagination>
          <pagination v-if="prod == 2" :limit="vPaginator.limit" :data="this.propiedadIntelectual" @pagination-change-page="getPropiedadIntelectual"></pagination>
        </div>
      <v-spacer></v-spacer>
      <investigador-email
        :show.sync="dialog"
        :investigador="currentInvestigadorName"
        :investigador-id="currentInvestigadorID"
      ></investigador-email>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import 'vuetify/dist/vuetify.min.css'
import {mapState, mapActions} from 'vuex'
import InvestigadorEmail from './InvestigadorEmail'
export default {
  props: ["urlApi","configuracion"],
  name: "productividad",
  components:{
    InvestigadorEmail
  },
  data() {
    return {
      columns1: [
        {label: "Titulo", field: "titulo"},
        {label: "Tipo", field: "producto"},
        {label: "Fecha", field: "fecha_final"},
        {label: "Investigador", field: "nombre_investigador"},
      ],
      columns2: [
        {label: "Titulo", field: "titulo"},
        {label: "Objetivo", field: "objetivo"},
        {label: "Tipo", field: "tipo"},
        {label: "Año", field: "fecha_inicio"},
        {label: "Investigador", field: "nombre_investigador"},
      ],
      productividad: [{id: 1, name: "Publicaciones"}, {id: 2, name: "Propiedad Intelectual"}],
      prod: [{id:1}, {id:2}],
      types:[{id:1, name: "Artículo"}, {id:2, name:"Capítulo de libro"}, {id:3, name:"Libro"}, {id:4, name:"Memoria"}, {id:5, name:"Reportes técnicos"}], 
      type:[],
      proptypes:[{id:1, name: "Diseño industrial o secreto comercial"},  {id:2, name:"Marca"}, {id:3, name:"Modelo de utilidad"}, {id:4, name:"Otro producto"}, {id:5, name: "Patente"}, {id:6, name:"Propiedad autoral"}, {id:7, name:"Propiedad industrial"},  {id:8, name: "Prototipo"}, {id:9, name:"Software"}, {id:10, name:"Tesis dirigida"}],
      proptype:[],
      years: [{id: 1, date: 2018}, {id: 2, date: 2019}, {id: 3, date: 2020},{id: 4, date: 2021},{id: 5, date: 2022},{id: 6, date: 2023}],
      year: [],
      search: '',
      dialog: false,
      currentInvestigadorID: null,
      currentInvestigadorName: null,
      publicaciones:{
        current_page: 1,
        data: []
      },
      propiedadIntelectual:{
        current_page: 1,
        data: []
      },
      publicacionesExcel: {
        data:[],
        default: ()=>[]
      },
      propiedadIntelectualExcel: {
        data:[],
        default: ()=>[]
      },
      vPaginator: {
        limit: 10
      },
    }
  },
  mounted(){
    this.getPublicaciones();
    this.getPropiedadIntelectual();
  },
  watch:{
    prod: function(value){
      if(value == 1 && this.type && this.year){
        this.search = '';
        this.year = [];
        this.getPublicaciones();
      }
      else if(value == 2 && this.proptype && this.year){
        this.search = '';
        this.year = [];
        this.getPropiedadIntelectual();
      }
    },
    type: function(value){
      if(value == this.type && this.prod == 1 ){
        this.search = '';
        this.getPublicaciones();
      }
      else if(value == this.proptype && this.prod == 2){
        this.search = '';
        this.getPropiedadIntelectual();
      }
    },
    proptype: function(value){
      if(value == this.proptype && this.prod == 2 ){
        this.search = '';
        this.getPropiedadIntelectual();
        
      }
      else if(value == this.type && this.prod == 1){
        this.search = '';
        this.getPublicaciones();
      }
    },
    year: function(value){
      if(value == this.year && this.prod == 1 && this.type){
        this.search = '';
        this.getPublicaciones();
      }
      else if(value == this.year && this.prod == 2 && this.proptype){
        this.search = '';
        this.getPropiedadIntelectual();
      }
    },
    search: function(value){
      if(this.prod == 1 && this.year && this.type){
        this.getPublicaciones();
        this.getPublicacionesExcel();
      }
      else if(this.prod == 2 && this.year && this.proptype){
        this.getPropiedadIntelectual();
        this.getPropiedadIntelectualExcel();
      }
    },
  },
  methods:{
    openMailModal: function(invID, name){
      this.dialog = true;
      this.currentInvestigadorID = invID;
      this.currentInvestigadorName = name;
    },
    getPublicaciones: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/publicaciones?page=${page}&query=${this.search}&firstQuery=Publicaciones&secondQuery=${this.type}&thirdQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => {this.publicaciones = response.data})
      .catch(error => errorHandling(error));
    },
    getPublicacionesExcel: function(){
      var url= process.env.VUE_APP_API_URL + `/api/publicaciones?perPage=500&page=1&query=${this.search}&firstQuery=Publicaciones&secondQuery=${this.type}&thirdQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => {this.publicacionesExcel = response.data})
      .catch(error => errorHandling(error));
    },
    getPropiedadIntelectual: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/propiedad-intelectual?page=${page}&query=${this.search}&firstQuery=Propiedad%20intelectual&secondQuery=${this.proptype}&thirdQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => {this.propiedadIntelectual = response.data})
      .catch(error => errorHandling(error));
    },
    getPropiedadIntelectualExcel: function(){
      var url= process.env.VUE_APP_API_URL + `/api/propiedad-intelectual?perPage=500&page=1&query=${this.search}&firstQuery=Propiedad%20intelectual&secondQuery=${this.proptype}&thirdQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => {this.propiedadIntelectualExcel = response.data})
      .catch(error => errorHandling(error));
    }
  },
  created(){
    this.getPublicaciones();
    this.getPublicacionesExcel();
  },
  computed:{
    prodCount: function(){
      if(this.prod == 1){
        return this.publicaciones.total;
      }
      else{
        return this.propiedadIntelectual.total;
      }
    }
  }
}
</script>
<style>
*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
  .v-label, .v-select__selection--comma{
    color: #0D47A1 !important;
  }
	.sci-prod-title{
		margin: 3% auto 0%;
		text-transform: uppercase;
		color: rgba(255,196,0,.9);
		font-weight: bold;
		font-size: 1.5em;
	}
	.sci-prod-dot{
		font-weight: bold;
		color: rgba(0,152,255,.9)
	}
  .theme--light.v-icon{
		color: #0D47A1;
	}
	.sci-prod-dot:before{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-right: 1.2%;
		border-radius: 1px 1px;
	}
	.sci-prod-dot:after{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-left: 1.2%;
		border-radius: 0 0 0 0;
	}
  .sci-prod-texto{
		width: 50%;
		margin: 1% auto;
		line-height: 1.5;
	}
  .sci-prod-content{
    width: 85%;
    margin: 3% auto 100px auto;
    border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;
		-webkit-border-radius: 10px 10px 10px 10px;
		border: 1px solid #aaa;
  }
  .sci-prod-row{
    margin: 2rem 0 0 0;
    /* display: grid; */
    background: transparent;
    font-size: 1em;
    color: #FFF;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr;
    text-transform: uppercase;
  }
  .sci-prod-vcont{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 90%;
    margin: 0 0 0 4vw;
    grid-gap: 0 3rem;
  }
  .sci-prod-busqueda {
    width: 100%;
    grid-template-columns: 3fr 3fr 3fr 2fr;
    border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 5px 5px 5px 5px;
  }
  .sci-prod-busqueda{
		color: black;
		display: grid;
		justify-content: start;
		width: 100%;
		grid-template-columns: 1fr;
		position: relative;
    margin: 2% 0 0 2%;
	}
  .sci-prod-busqueda input{
    background: #FFF;
    width: 63%;
    height: 25px;
    margin: 0 0 13px 0;
    border-radius: 0px 0 0 0px;
    border: none;
    padding: 0 15px;
    font-size: .8em;
    position: relative;
    background: gainsboro;
    padding: 15px;border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 1px solid #aaa;
  }
  .sci-prod-busqueda input:focus{
    outline: 0;
  }
  .sci-prod-busqueda input::placeholder{
    text-transform: uppercase;
  }
  .sci-prod-lupa{
    background: #0084FF;
    border: none;
    width: 35px;
    height: 32px;
    padding: 15px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    position: absolute;
    top: 0;
    left: 56%;
  }
  .sci-prod-lupa:before{
    display: inline-block;
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid #FFF;
    position: relative;
    left: -6px;
    top: -12px;
  }
  .sci-prod-lupa:after{
    content: '';
    width: 10px;
    height: 2px;
    display: inline-block;
    background: #FFF;
    transform: rotate(45deg);
    position: absolute;
    top: 18px;
    left: 17px;
  }
  .sci-prod-excel{
		font-weight: bold;
		color: rgb(117, 180, 239);
		font-size: 1.1rem;
		border: 1px solid #ccc;
		padding: .4rem;
		margin: 1rem 0 1rem 0;
		border-radius: 5px;
		display: grid;
	}
  .sci-prod-count{
		color: #0D47A1;
		font-size: 1.03rem;
		font-weight: bold;
		display: grid;
		text-align: left;
		padding: 1rem;
	}
  .sci-prod-row2{
    display: grid;
    background: rgba(0,0,36,.9);
    font-size: 1em;
    color: #FFF;
    grid-template-columns: 1fr;
    width: 109%;
    
  }
  .sci-prod-row2 tr{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    
  }
  .sci-prod-col{
    align-self: center;
  }
  .sci-prod-input{
    border-radius: 0px;
    border: none;
  }
  .form-row > [class*="col-"]{
    display: none;
  }
  .sci-prod-form{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .sci-prod-form label{
    align-self: center;
    margin: 0;
  }
  .sci-prod-contCheck{
   display: grid;
   align-content: center;
  }
  .sci-prod-paddCheck{
   margin-bottom: 0;
  }
  .sci-prod-noData{
    color: #000;
    margin: 1rem;
    font-weight: bold;
    font-size:1.1rem;
  }
  .sci-prod-thead{
    display: grid;
    grid-column: 1/4;
    padding: 15px;
    width: 100%;
  }
  .sci-prod-thead tr{
    display: grid;
    grid-template-columns: 4fr 2fr 2fr 3fr 1fr;
    color: black;
  }
  .sci-prod-thead2{
    display: grid;
    grid-template-columns: 3fr 5fr 3fr 1fr 3fr 1fr !important;
    color: black;
  }
  .sci-prod-tbody{
    display: grid;
    text-align: left;
    padding: 15px;    
  }
  .sci-prod-tbody tr{
    display: grid;
    grid-template-columns: 4fr 2fr 2fr 3fr 1fr;
    padding: 10px 0;
    text-transform: uppercase;
  }
  .sci-prod-tbody tr td{
    padding: 0 .5rem;
  }
  .sci-prod-tbody tr :nth-child(3), .sci-prod-tbody tr :nth-child(2){
    text-align: center;
  }
  .sci-prod-tbody2 tr{
    display: grid;
    grid-template-columns: 3fr 5fr 3fr 1fr 3fr 1fr !important;
    padding: 10px 0;
    text-transform: uppercase;
    text-align: left;
    padding: 0 .5rem;
  }
  .sci-prod-tbody2 tr td{
    padding: .5rem .5rem;
  }
  .sci-prod-tbody2 tr :nth-child(3){
    text-align: center;
  }
  .sci-prod-table{
    margin-bottom: 100px;
  }
  @media only screen and (max-width: 850px) and (min-width: 100px) {
		.sci-prod-content{
      width: 90%;
			grid-template-areas: "sci-prod-table";
			grid-template-columns: 1fr;
		}
		.sci-prod-table{
			width: 100%;
			margin: 2% auto;
		}
    .sci-prod-row{
      grid-template-columns: 2fr 3fr;
    }
	}
  @media screen and (max-width: 600px) and (min-width: 50px){
    .sci-prod-content{
      width: 97%;
    }
    .sci-prod-tr1{
      font-size: .87rem;
    }
    .sci-prod-row{
      grid-template-columns: 120px 1fr;
      grid-template-rows: 1fr 1fr;
      height: 120px;
      
    }
  }
  .text-center{
    text-align: center;
  }
</style>